module.exports = __webpack_public_path__ + "static/favicon-a3b501418d037661b68c64f24276d125.ico";